import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-77499544"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "viewDetails" }

import { useRouter } from "vue-router";
import { setField } from "@/utiles/utiles";
import { ref, reactive, onMounted, toRaw} from "vue";
import TargetInfo from "./components/TargetInfo.vue";
import SimilarTarget from "./components/SimilarTarget.vue";
import { appTargetDetail } from "@/views/VerificationData/api.js";

export default /*#__PURE__*/_defineComponent({
  __name: 'viewDetails',
  props: ['form', 'id','targetInfo','targetType'],
  setup(__props) {

const { form, id ,targetInfo,targetType} = __props;


const Router = useRouter();


const goBack = () => {
  Router.back();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(TargetInfo, {
      targetInfo: __props.targetInfo.targetInfo,
      ossUrl: __props.targetInfo.ossUrl,
      cosUrl: __props.targetInfo.cosUrl,
      form: __props.form,
      id: __props.id,
      targetType: __props.targetType,
      goBack: goBack,
      type: true,
      farmerInfo: __props.targetInfo.farmerInfo
    }, null, 8, ["targetInfo", "ossUrl", "cosUrl", "form", "id", "targetType", "farmerInfo"]),
    _createVNode(SimilarTarget, {
      form: __props.form,
      targetInfo: __props.targetInfo,
      targetType: __props.targetType,
      ossUrl: __props.targetInfo.ossUrl,
      cosUrl: __props.targetInfo.cosUrl
    }, null, 8, ["form", "targetInfo", "targetType", "ossUrl", "cosUrl"])
  ]))
}
}

})